import { PasswordInput, Button, Flex, Box, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import classes from './resetPassword.module.scss';
import { zodResolver } from 'mantine-form-zod-resolver';
import { VALIDATE_SCHEMA } from './types';
import { useResetPassword } from '@entities/auth/api/hooks/mutations';
import { showNotification } from '@shared/utils';
import { useNavigate, useSearchParams } from 'react-router';

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const navigate = useNavigate();
  const {
    mutate: mutateResetPassword,
    isPending,
    isSuccess,
  } = useResetPassword();

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      password: '',
      passwordConfirmation: '',
    },
    validate: zodResolver(VALIDATE_SCHEMA),
  });

  const handleSubmit = (values: typeof form.values) => {
    if (!token) {
      return;
    }

    mutateResetPassword(
      { ...values, token },
      {
        onSuccess: () => {
          navigate('/auth');
        },
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message || 'Ошибка при отправке запроса',
          });
        },
      }
    );
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Flex gap='1rem' direction='column'>
        <Box>
          <Flex justify='space-between' align='flex-start'>
            <Text
              component='label'
              htmlFor='password'
              className={classes.label}
            >
              Пароль
            </Text>
          </Flex>

          <PasswordInput
            {...form.getInputProps('password')}
            key={form.key('password')}
            type='password'
            w='100%'
            id='password'
            error={form.errors.password}
            radius='0.75rem'
          />
        </Box>

        <Box>
          <Flex justify='space-between' align='flex-start'>
            <Text
              component='label'
              htmlFor='password'
              className={classes.label}
            >
              Подтверждение пароля
            </Text>
          </Flex>

          <PasswordInput
            {...form.getInputProps('passwordConfirmation')}
            key={form.key('passwordConfirmation')}
            type='password'
            w='100%'
            id='passwordConfirmation'
            radius='0.75rem'
            error={form.errors.passwordConfirmation}
          />
        </Box>
      </Flex>

      <Button
        type='submit'
        mt='2rem'
        fullWidth
        className={classes.resetButton}
        variant='primary'
        loading={isPending}
        disabled={isPending || isSuccess}
      >
        Восстановить
      </Button>
    </form>
  );
};
